var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburgerinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "Indmoney Menu"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 7h18M1 1h18M7 13h12",
    stroke: "#47494C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgHamburgerinline;